import { createHistory } from 'history';
import { useRouterHistory } from 'react-router';
import { env } from 'src/config/env';

export const browserHistory = useRouterHistory(createHistory)({
  basename: env.ROUTE_BASEPATH === '/' ? '' : env.ROUTE_BASEPATH,
});
